import React, { useState } from "react";
import { withRouter, useHistory } from "react-router-dom";
import $ from "jquery";
import {
  Heading,
  TextContainer,
  Card,
  Button,
  Modal,
  Link,
} from "@shopify/polaris";
import logo from "../Images/dashboard.png";
import preview from "../Images/preview.png";
import * as authService from "../../services/authService";
import { useSelector, useDispatch } from "react-redux";
import userData from "../../staticenv";
import ReactPlayer from "react-player/youtube";
export default function AcoountActivation() {
  const history = useHistory();
  const [loadingOrderLink, setLoadingOrderLink] = useState(false);
  const [modalOrderLink, setModalOrderLink] = useState(false);
  const [videoModal, setvideoModal] = useState(false);

  const status_change = useSelector((state) => state.allReducer.status_change);

  const handleDeleteClose = () => {
    setModalOrderLink(false);
  };
  const handlePreviewPage = () => {
    // setRoute("/preview");
    // window.location.href = "javascript:$zopim.livechat.window.hide();";
    // $(".sc-Axmtr").click()
    setLoadingOrderLink(true);
    authService
      .previewOrderLink()
      .then((response) => {
        setLoadingOrderLink(false);
        if (response && response.data && response.data.data) {
          window.open(response.data.data, "_blank");
        } else {
          setModalOrderLink(true);
        }
      })
      .catch((error) => {
        setLoadingOrderLink(false);

        console.log(error);
      });
  };
  return (
    <Card sectioned>
      <div style={{ textAlign: "center", margin: "30px" }}>
        <img style={{ width: "180px" }} src={logo}></img>
        <br />
        <br />

        <TextContainer>
          <Heading>Create Your Account Activation Block</Heading>
          <p>
            Increase user account activations with a customizable block that
            invites users to activate their account from the order confirmation
            page.
          </p>
        </TextContainer>
        <br />

        <Button
          primary
          onClick={() => {
            history.push("/appearance");
          }}
        >
          Edit Account Block
        </Button>
        {"                   "}
        {/* <Button
                    loading={loadingOrderLink}
                    monochrome={!loadingOrderLink}
                    onClick={() => {
                        status_change && status_change.status
                            ? handlePreviewPage()
                            : setModalOrderLink(true);
                        // history.push("/preview");
                    }}
                >
                    Preview
                </Button> */}
        <Button
          loading={loadingOrderLink}
          monochrome={!loadingOrderLink}
          onClick={() => {
            // status_change && status_change.status
            //   ? handlePreviewPage()
            //   : setModalOrderLink(true);
            setvideoModal(true);
          }}
        >
          Watch Video Guide
        </Button>
      </div>
      <Modal
        open={modalOrderLink}
        onClose={handleDeleteClose}
        title="Preview Activation Message"
        secondaryActions={[
          {
            content: "Close",
            onAction: handleDeleteClose,
          },
        ]}
      >
        <Modal.Section>
          {status_change && status_change.status ? (
            <TextContainer>
              <p>
                To preview your activation message go to one of your{" "}
                <Link
                  onClick={() => {
                    window.open(`https://${userData.shop}/admin/orders`);
                  }}
                >
                  {" "}
                  recent orders
                </Link>
                , and select 'More Actions' located at the top right, and from
                the dropdown choose 'View order status page'.
              </p>
              <br />
              <img style={{ width: "180px" }} src={preview}></img>
              <br />

              <p>
                Make sure you choose an order from a customer that has yet to
                create an account, as the message does not show for already
                created accounts.
              </p>
            </TextContainer>
          ) : (
            <TextContainer>
              <p>Please enable the app first. </p>
            </TextContainer>
          )}
        </Modal.Section>
      </Modal>
      {videoModal && (
        <Modal
          // activator={activator}
          open={videoModal}
          large={true}
          onClose={() => setvideoModal(false)}
        >
          <Modal.Section>
            <ReactPlayer
              url="https://www.youtube.com/watch?v=9AP9X_SrvL8"
              playing={true}
              controls={true}
              width="100%"
              height="460px"
              className="videoClose"
            />
          </Modal.Section>
        </Modal>
      )}
    </Card>
  );
}
